document.addEventListener("DOMContentLoaded", function () {
  var modals = document.querySelectorAll(".k-modal");
  var modalClose_btns = document.querySelectorAll(".k-modal-close");
  var modalInfo = document.querySelector("#info.k-modal");
  var jobTitleInput = document.getElementById("job-title");

  // Event listener for successful form submission
  document.addEventListener(
    "wpcf7mailsent",
    function (event) {
      event.target.classList.add("modal-success");
      event.target.classList.remove("modal-error");
    },
    false
  );

  // Event listener for form validation error
  document.addEventListener(
    "wpcf7invalid",
    function (event) {
      event.target.classList.add("modal-error");
      event.target.classList.remove("modal-success");
    },
    false
  );

  // Event listener for form submission failure
  document.addEventListener(
    "wpcf7mailfailed",
    function (event) {
      event.target.classList.add("modal-error");
      event.target.classList.remove("modal-success");
    },
    false
  );

  function openModal(type) {
    for (let modal of modals) {
      if (
        modal.getAttribute("id") == type &&
        modal.querySelector(".k-modal-content").innerHTML.trim() !== ""
      ) {
        modal.classList.add("show-modal");
        document.body.style.overflow = "hidden";
      }
    }
  }

  function closeModal() {
    for (let modal of modals) {
      modal.classList.remove("show-modal");
      document.body.style.overflow = "";
      if (modal.getAttribute("id") == "info") {
        var modalContent = modal.querySelector(".k-modal-content");
        var modalTitle = modal.querySelector(".k-modal-title");
        modalContent.innerHTML = "";
        modalTitle.innerHTML = "Modal";
      } else {
        var modalInputs = modal.querySelectorAll(
          "input[type=text],textarea,input[type=email]"
        );
        for (let modalInput of modalInputs) {
          modalInput.value = "";
        }
        if (modal.querySelector(".wpcf7-form")) {
          modal.querySelector(".wpcf7-form").className = "wpcf7-form init";
          modal
            .querySelector(".wpcf7-form")
            .setAttribute("data-status", "init");
        }
      }
    }
  }

  let modal_btns = document.querySelectorAll(".k-modal-btn");
  for (let btn of modal_btns) {
    btn.addEventListener("click", function () {
      var type = this.getAttribute("data-type");
      var postId = this.getAttribute("data-post-id");
      var title = this.getAttribute("data-title");
      var inputField = document.getElementById("your-position-candidate");
      if (inputField) {
        inputField.value = title;
      }
      var imageUrl = "";

      var img = this.querySelector("img");
      if (img) {
        imageUrl = img.src;
      }

      if (type.indexOf("_form") > 0) {
        openModal(type);
      } else {
        var xhr = new XMLHttpRequest();
        xhr.open(
          "GET",
          ajax_object.ajax_url +
            "?action=modal&type=" +
            type +
            "&post_id=" +
            postId +
            "&image_url=" +
            encodeURIComponent(imageUrl),
          true
        );
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            var response = JSON.parse(xhr.responseText);
            var modalContent = modalInfo.querySelector(".k-modal-content");
            var modalTitle = modalInfo.querySelector(".k-modal-title");
            modalContent.innerHTML = response.content;
            modalTitle.innerHTML = response.title;
            openModal("info");
          }
        };
        xhr.send();
      }
    });
  }

  for (let modalClose_btn of modalClose_btns) {
    modalClose_btn.addEventListener("click", closeModal);
  }
  document.addEventListener("click", function (event) {
    for (let modal of modals) {
      if (event.target === modal) {
        closeModal();
      }
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeModal();
    }
  });
});
